import type { FC } from 'react'
import { Outlet } from 'react-router'

import Navbar from '@/lib/ui/navbar'
import Footer from '@/lib/ui/footer'

export const Layout: FC = () => (
  <div className='flex items-center justify-center'>
    <div className='flex min-h-dvh w-full max-w-5xl flex-col'>
      <Navbar className='sticky top-0' />
      <main className='grow'>
        <Outlet />
      </main>
      <Footer />
    </div>
  </div>
)

export default Layout
